
const getQuery = reqParams => {
    return Object.keys(reqParams)
        .reduce((a, k) => {
          a.push(k + '=' + encodeURIComponent(reqParams[k]));
          return a;
        }, [])
        .join('&');
};

export { getQuery };